import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-get-demo',
  templateUrl: './get-demo.component.html',
  styleUrls: ['./get-demo.component.scss'],
  imports: [LangRouterLink, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetDemoComponent {}
